import { When } from "../../../../components/when";
import { AgencySelfApplySignInButton } from "../../agency/components/agency-sign-in-button";

export const NoJobAvailable = (props: {
  orgDisplayName: string;
  atsEnabled: boolean;
  needsSignin?: boolean;
}) => {
  return (
    <div className="mx-auto flex h-full w-full max-w-6xl flex-col items-center justify-center px-6">
      {/* Decorative so empty alt */}
      <img
        src="/v2/document-search-gray.svg"
        className="h-auto w-[220px]"
        alt=""
      />
      <When condition={!props.needsSignin}>
        <p className="font-inter text-charcoal max-w-sm pt-12 text-center text-4xl font-semibold">
          {props.atsEnabled
            ? props.orgDisplayName + " has no job openings at the moment."
            : props.orgDisplayName +
              " has not enabled the Applicant Tracking feature."}
        </p>
        <p className="text-charcoal max-w-sm pt-2 text-center text-base">
          {props.atsEnabled
            ? "Please check back later."
            : "Please contact your system administrator."}
        </p>
      </When>
      <When condition={props.needsSignin}>
        <When condition={props.atsEnabled}>
          <p className="font-inter text-charcoal max-w-sm pb-3  pt-8 text-center text-4xl font-semibold">
            If you are a recruiting agency, please sign in to view job openings.
          </p>
          <AgencySelfApplySignInButton />
        </When>
        <When condition={!props.atsEnabled}>
          <p className="font-inter text-charcoal max-w-sm pb-3 pt-12 text-center text-4xl font-semibold">
            {`${props.orgDisplayName} has not enabled the Applicant Tracking feature.`}
          </p>
          <p className="text-charcoal max-w-sm pt-2 text-center text-base">
            Please contact your system administrator.
          </p>
        </When>
      </When>
    </div>
  );
};
